import { generated } from '@varos/research-sdk-api';
import { FieldType } from '../../../../common/type';
import {
    DocumentFormFieldOption,
    DocumentFormFieldValues,
    DocumentFormFormValues,
} from './formStateModel';
import { FormInterviewMetadataSchema } from '../formBuilderSchema';

/**
 * Generate a local ID for new form fields/options
 * These are used for form state management and should not be sent to the server
 */
export function generateLocalId(): string {
    return `_local_${crypto.randomUUID()}`;
}

export function buildFormStateValues(props: {
    form: generated.Form;
    transcript: {
        key: string;
    };
}): DocumentFormFormValues {
    const metadata = FormInterviewMetadataSchema.partial().parse(props.form.metadata);
    return {
        title: props.form.title,
        description: props.form.description || null,
        agentName: metadata.interview_agent_name ?? null,
        context: metadata.interview_context ?? null,
        goals: metadata.interview_goals ?? null,
        tone: metadata.interview_agent_tone ?? null,
        fields: props.form.config?.fields
            .filter((field) => field.key !== props.transcript.key)
            .map(
                (field): DocumentFormFieldValues => ({
                    _local_id: field.id, // Use server ID as local ID for existing fields
                    id: field.id, // Real server ID
                    title: field.display_name,
                    type: field.type as FieldType,
                    required: field.required,
                    description: field.description,
                    showDescription: Boolean(field.description),
                    formula: field.formula ?? null,
                    options:
                        field.type === 'enum'
                            ? field.config.options.map(
                                  (option): DocumentFormFieldOption => ({
                                      _local_id: option.id, // Use server ID as local ID for existing options
                                      id: option.id, // Real server ID
                                      displayName: option.display_name,
                                  })
                              )
                            : null,
                })
            ),
        config: {
            capture_email: props.form.config?.capture_email ?? false,
            access_level: props.form.config?.access_level ?? 'workspace',
        },
    };
}
